<template>
  <div class="echart03">
    <div ref="echart03" style="width:100%; height:200px;"></div>
  </div>
</template>

<script>
export default {
  props:{
    data03:{type: Object}
  },
  mounted() {
    let chart03 = this.$echarts.init(this.$refs.echart03)
    // let xData = ['61-65', '56-60', '51-55', '46-50', '41-45', '36-40', '31-35', '20-30']
    let xData = ['20-30', '31-35', '36-40', '41-45', '46-50', '51-55', '56-60', '61-65']
    // let data1 = ['24', '23', '43', '13', '42', '53', '23', '42']
    let data1 =this.data03.manAges;
    // let data2 = ['54', '73', '32', '53', '41', '15', '74', '14']
    let data2=this.data03.womanAges;

    let option = {
      timeline: {
        show: false,
        top: 0,
        data: []
      },
      tooltip: {
        show: true
      },
      grid: [
        // 左边柱子
        {
          show: false,
          left: '5%',
          top: '6%',
          bottom: '20',
          containLabel: true,
          width: '36%'
        },
        // 中间
        {
          show: false,
          left: '52%',
          top: '6%',
          bottom: '20',
          width: '0%'
        },
        // 右边柱子
        {
          show: false,
          right: '5%',
          top: '5%',
          bottom: '20',
          containLabel: true,
          width: '36%'
        }
      ],
      xAxis: [
        {
          type: 'value',
          inverse: true,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        {
          gridIndex: 1,
          show: false
        },
        {
          gridIndex: 2,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        }
      ],
      yAxis: [
        {
          type: 'category',
          inverse: true,
          position: 'right',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: xData
        },
        {
          gridIndex: 1,
          type: 'category',
          inverse: true,
          position: 'center',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            align: 'center',
            color: 'white',
            fontSize: 12
          },
          data: xData
        },
        {
          gridIndex: 2,
          type: 'category',
          inverse: true,
          position: 'left',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: xData
        }
      ],
      series: [
        {
          name: '男',
          type: 'bar',
          xAxisIndex: 0,
          yAxisIndex: 0,
          barWidth: 10,
          showBackground: true,
          itemStyle: {
            borderRadius: 0,
            color: '#1d70e1'
          },
          label: {
            show: true,
            position: 'left',
            color: '#1d70e1'
          },
          data: data1
        },
        {
          name: '女',
          type: 'bar',
          xAxisIndex: 2,
          yAxisIndex: 2,
          barWidth: 10,
          showBackground: true,
          itemStyle: {
            borderRadius: 0,
            color: "#fe922a"
          },
          label: {
            show: true,
            position: 'right',
            color: '#fe922a'
          },
          data: data2
        }
      ]
    }
    chart03.setOption(option, true)
  }
}
</script>

<style scoped>
.echart03 {
  font-size: 10px;
  font-weight: 700;
  width: 90%;
  margin: 0 5%;
}
</style>
